/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const TaskSubscription = gql`
  subscription TaskSubscription($taskName: String!, $projectId: String) {
    taskSubscription(taskName: $taskName, projectId: $projectId) {
      id
      taskName
      projectId
      state {
        status
        statusCode
      }
      error
      metadata
    }
  }
`;
